import '../init';

import { i18nReact } from '@rhim/i18n';
import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

import { environment } from '../environments/environment';
import { initializeAnalytics } from '../lib/analytics';

async function bootstrap() {
  initializeAnalytics();
  void i18nReact.initialize({ lng: i18nReact.getLocaleFromStorage() });

  if (environment.allowExtensions) {
    await import('@rhim/react/side-effects/whyDidYouRender');
  }

  startTransition(() => {
    hydrateRoot(
      document,
      environment.isUnderTest === true ? (
        <HydratedRouter />
      ) : (
        <StrictMode>
          <HydratedRouter />
        </StrictMode>
      )
    );
  });
}

void bootstrap();
